exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".device-info-modal .ele-0 {\n  text-align: right;\n}\n.device-info-modal .no-edit {\n  margin-bottom: 20px;\n}\n.device-info-modal .no-edit,\n.device-info-modal .able-edit {\n  font-size: 14px;\n}\n.device-info-modal .no-edit label,\n.device-info-modal .able-edit label {\n  font-size: 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/device/list/edit/index.less
// module id = 938
// module chunks = 0